module.exports = __webpack_public_path__ + "static/tgLogoRed-2e68a5b6e5c0f2f37c792597e8e820f6.png";